module.exports = __webpack_public_path__ + "img/7.321c4de6.png";